<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5" v-if="!mainSearch.query.fcCode">
                    <el-form-item label="生产组织" class="EL-Form-Item">
                        <el-select v-model="mainSearch.query.fcCode" placeholder="请选择" clearable="clearable">
                            <el-option label="DLM大连一厂" value="DLM" />
                            <el-option label="DLN大连二厂" value="DLN" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.query.whCode" placeholder="请选择" clearable="clearable" filterable>
                            <el-option v-for="item in WhCodeList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.matName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item" v-if="mainSearch.query.fcCode">
                        <el-select v-model="mainSearch.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode">
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="inquireDataClick('mainSearch')">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetClick()">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item" v-if="!mainSearch.query.fcCode">
                        <el-select v-model="mainSearch.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode">
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.batchNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                  <el-form-item label="质检状态" class="EL-Form-Item">
                    <el-select v-model="mainSearch.query.checkResult" clearable="clearable">
                      <el-option key="0" value="" label="全部"></el-option>
                      <el-option label="待检" value="10"> </el-option>
                      <el-option label="合格" value="20"> </el-option>
                      <el-option label="不合格" value="30"> </el-option>
                      <el-option label="退货" value="40"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="库存列表">
                <el-button class="btn-t-edit" type="primary" @click="labelPrint()">标签打印</el-button>
               <el-button class="btn-t-edit" v-authority="'BACK_MENU6_M1_B10'" @click="showUnpackingDialog">拆包</el-button>
                <el-button v-authority="'BACK_MENU6_M1_B1'" class="btn-t-edit" type="primary" @click="Outsourcrecord()">外协新增</el-button>
                <el-button v-authority="'BACK_MENU6_M1_B2'" class="btn-t-edit" type="primary" @click="openOutsourceTransfer()">外协移库</el-button>
                <el-button v-authority="'BACK_MENU6_M1_B3'" class="btn-t-edit" type="primary" @click="openOutsourceReceiving()">外协接收</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" @pageChange="getTableData" :data="mainSearch.data" pagination :nowPage.sync="mainSearch.pageNum" :pageSize.sync="mainSearch.pageSize" :total.sync="mainSearch.total" @selectionChange="selectOutsource">/
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="通道编号" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="批次号" prop="batchNo" align="center">
                </el-table-column>
                <el-table-column label="库位" prop="lcCode" align="center">
                </el-table-column>
                <el-table-column label="库存状态" align="center" prop="wiStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <el-table-column label="质检状态" align="center" prop="wiStatus">
                  <template slot-scope="scope">
                    <span v-if="scope.row.checkResult == '10'">待检</span>
                    <span v-if="scope.row.checkResult == '20'">合格</span>
                    <span v-if="scope.row.checkResult == '30'">不合格</span>
                    <span v-if="scope.row.checkResult == '40'">退货</span>
                  </template>
                </el-table-column>
                <el-table-column label="包装箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <el-table-column label="生产时间" prop="matCreateTime" align="center" width="140px">
                </el-table-column>
            </h-table>
            <!-- 新增-->
            <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="editBoxShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :model="mainObj">
                <div style="overflow: hidden; padding-bottom: 10px">
                    <el-form label-position="right" label-width="100px" :model="mainObj" :rules="rules" ref="mainObj">
                        <el-col :lg="6" :xl="6">
                            <el-form-item label="外协单号" prop="soCode" class="EL-Form-Item">
                                <el-input v-model.trim="mainObj.soCode"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="6" :xl="6">
                            <el-form-item label="外协供应商" prop="laOutsouceCode" class="EL-Form-Item">
                                <el-select v-model="mainObj.laOutsouceCode" filterable placeholder="请选择" clearable="clearable">
                                    <el-option v-for="item in laCodeList" :key="item.whId" :value="item.lcCode" :label="item.lcCode">{{item.lcCode}}--{{item.lcName}}</el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :lg="6" :xl="6">
                            <el-form-item label="箱号" prop="boxBarcode" class="EL-Form-Item">
                                <el-input v-model.trim="mainObj.boxBarcode"> </el-input>
                            </el-form-item>
                        </el-col> -->
                        <!-- <el-col :lg="4" :xl="4">
                            <el-form-item class="btn-edit-delete EL-Form-Item">
                                <el-button type="primary" class="btn-t-edit" @click="pushOutsourceList()">添加</el-button>
                            </el-form-item>
                        </el-col> -->
                    </el-form>
                </div>
                <div>
                    <h-table :style="$popups.harvestRecordStyle(0.63)" :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" :data="addOutsourceLists" @selectionChange="selectOutsources">
                         <el-table-column type="selection" align="center"> </el-table-column>
                        <el-table-column label="通道" prop="whCode" align="center">
                        </el-table-column>
                        <el-table-column label="物料编号" prop="matCode" align="center">
                        </el-table-column>
                        <el-table-column label="物料描述" prop="matName" align="center">
                        </el-table-column>
                        <el-table-column label="箱号" prop="boxBarcode" palign="center">
                        </el-table-column>
                        <el-table-column label="批次" prop="batchNo" align="center">
                        </el-table-column>
                        <el-table-column label="数量" prop="matQuan" align="center">
                        </el-table-column>
                        <el-table-column label="库位" prop="lcCode" align="center">
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button v-authority="'XCMENUCODE'" class="btn-t-delete" type="danger" @click="deletelist(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </h-table>
                </div>
                <div slot="footer" class="dialog-footer footer-bottom">
                    <el-button size="small" type="info" @click="editBoxShow = false">
                        取 消
                    </el-button>
                    <el-button size="small" type="primary" @click="insertOutsource()">
                        新 增
                    </el-button>
                </div>
            </el-dialog>

            <!-- 外协记录列表-->
            <el-dialog title="外协记录列表" :close-on-click-modal="false" :visible.sync="editBoxShows" class="fromDialog" :style="$popups.popups(0.8,0.9)" :model="pagination">
                <div style="overflow: hidden; padding-bottom: 10px">
                    <el-form label-position="right" label-width="100px">
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="通道" class="EL-Form-Item">
                                <el-select v-model="pagination.whCode" filterable placeholder="请选择" clearable="clearable">
                                    <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="物料编号" class="EL-Form-Item">
                                <el-input v-model="pagination.matCode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="库位" class="EL-Form-Item">
                                <el-input v-model="pagination.laCode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="箱号" class="EL-Form-Item">
                                <el-input v-model="pagination.boxBarcode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="4" :xl="4">
                            <el-form-item class="btn-edit-delete EL-Form-Item">
                                <el-button class="btn-t-edit" @click="getOutsource()">
                                    查询
                                </el-button>
                                <el-button class="btn-t-delete" @click="resetData()">
                                    重置
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="外协单号" class="EL-Form-Item">
                                <el-input v-model="pagination.soCode" placeholder="请输入">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="状态" class="EL-Form-Item">
                                <el-select v-model="pagination.soStatus">
                                    <el-option label="默认(进行中,拣配完成,出库完成)" value="20,60,30"></el-option>
                                    <el-option label="进行中" value="20"></el-option>
                                    <el-option label="出库完成" value="30"></el-option>
                                    <el-option label="拣配完成" value="60"></el-option>
                                    <el-option label="收货完成" value="40"></el-option>
                                    <el-option label="关闭" value="50"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </div>
                <div class="dao"> 
                    <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="closeOutsourcing()">关闭外协单</el-button>
                    <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="submitMovement()">移库</el-button>
                 <el-button v-authority="'XCMENUCODE'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
               </div>
                <div>
                    <h-table :style="$popups.harvestRecordStyle(0.56)" :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal" @selectionChange="selectOutsource">
                        <el-table-column type="selection" align="center"></el-table-column>
                        <el-table-column label="外协单号" prop="soCode" align="center">
                        </el-table-column>
						<el-table-column label="外协供应商" prop="laOutsouceCode" align="center">
                        </el-table-column>
                        <el-table-column label="状态" prop="soStatus" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.soStatus == '20'">进行中</div>
                                <div v-if="scope.row.soStatus == '30'">出库完成</div>
                                <div v-if="scope.row.soStatus == '60'">拣配完成</div>
                                <div v-if="scope.row.soStatus == '40'">收货完成</div>
                                <div v-if="scope.row.soStatus == '50'">关闭</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建人" prop="person" palign="center">
                        </el-table-column>
                        <el-table-column label="创建时间" prop="createTime" align="center">
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="300px">
                            <template slot-scope="scope">
                                <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="detailsDialogShow = true,getOutsourceDetail(scope.row.soCode,scope.row.soStatus)">详情</el-button>
                                <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="scanOutsource(scope.row.soCode)" :disabled="scope.row.soStatus==30 ? false:true">外协接收</el-button>
                                <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="DialogReceptionShows = true,getOutsourcePrint(scope.row.soCode)">接收记录</el-button>
                            </template>
                        </el-table-column>
                    </h-table>
                </div>
                <div slot="footer" class="dialog-footer footer-bottom">
                    <el-button size="small" type="info" @click="resetData(),editBoxShows = false">
                        取 消
                    </el-button>
                </div>
            </el-dialog>

            <!-- 外协移库列表-->
            <el-dialog title="外协移库列表" :close-on-click-modal="false" :visible.sync="editBoxShows" class="fromDialog" :style="$popups.popups(0.8,0.9)" :model="pagination">
                <div style="overflow: hidden; padding-bottom: 10px">
                    <el-form label-position="right" label-width="100px">
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="通道" class="EL-Form-Item">
                                <el-select v-model="pagination.whCode" filterable placeholder="请选择" clearable="clearable">
                                    <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="物料编号" class="EL-Form-Item">
                                <el-input v-model="pagination.matCode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="库位" class="EL-Form-Item">
                                <el-input v-model="pagination.laCode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="箱号" class="EL-Form-Item">
                                <el-input v-model="pagination.boxBarcode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="4" :xl="4">
                            <el-form-item class="btn-edit-delete EL-Form-Item">
                                <el-button class="btn-t-edit" @click="getOutsource()">
                                    查询
                                </el-button>
                                <el-button class="btn-t-delete" @click="resetData()">
                                    重置
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="外协单号" class="EL-Form-Item">
                                <el-input v-model="pagination.soCode" placeholder="请输入">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="状态" class="EL-Form-Item">
                                <el-select v-model="pagination.soStatus">
                                    <el-option label="默认(进行中,发货完成)" value="20,80,90"></el-option>
                                    <el-option label="进行中" value="20"></el-option>
                                  <!--<el-option label="出库完成" value="30"></el-option>
                                   <el-option label="拣配完成" value="60"></el-option> -->
                                   <el-option label="发货完成" value="80"></el-option>
                                   <!-- <el-option label="收货完成" value="40"></el-option> -->
                                    <el-option label="关闭" value="50"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </div>
                <div class="dao">
                    <el-button v-authority="'BACK_MENU6_M1_B4'" class="btn-t-edit" type="primary" @click="closeOutsourcing()">关闭外协单</el-button>
                    <!--<el-button v-authority="'BACK_MENU6_M1_B5'" class="btn-t-edit" type="primary" @click="submitMovement()">移库</el-button>-->
                 <el-button v-authority="'BACK_MENU6_M1_B6'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
               </div>
                <div>
                    <h-table :style="$popups.harvestRecordStyle(0.56)" :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal" @selectionChange="selectOutsource">
                        <el-table-column type="selection" align="center"></el-table-column>
                        <el-table-column label="外协单号" prop="soCode" align="center">
                        </el-table-column>
						<el-table-column label="外协供应商" prop="laOutsouceCode" align="center">
                        </el-table-column>
                        <el-table-column label="状态" prop="soStatus" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.soStatus == '20'">进行中</div>
                                <div v-if="scope.row.soStatus == '30'">出库完成</div>
                                <!--<div v-if="scope.row.soStatus == '60'">发货完成</div>-->
                                <div v-if="scope.row.soStatus == '40'">收货完成</div>
                                <div v-if="scope.row.soStatus == '80'">发货完成</div>
                                <div v-if="scope.row.soStatus == '50'">关闭</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建人" prop="person" palign="center">
                        </el-table-column>
                        <el-table-column label="创建时间" prop="createTime" align="center">
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="300px">
                            <template slot-scope="scope">
                                <el-button v-authority="'BACK_MENU6_M1_B7'" class="btn-t-edit" type="primary" @click="detailsDialogShow = true,getOutsourceDetail(scope.row.soCode,scope.row.soStatus)">详情</el-button>
                                <!-- <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="scanOutsource(scope.row.soCode)" :disabled="scope.row.soStatus==30 ? false:true">外协接收</el-button>
                                <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="DialogReceptionShows = true,getOutsourcePrint(scope.row.soCode)">接收记录</el-button> -->
                            </template>
                        </el-table-column>
                    </h-table>
                </div>
                <div slot="footer" class="dialog-footer footer-bottom">
                    <el-button size="small" type="info" @click="resetData(),editBoxShows = false">
                        取 消
                    </el-button>
                </div>
            </el-dialog>

            <!-- 外协接收列表-->
            <el-dialog title="外协接收列表" :close-on-click-modal="false" :visible.sync="editBoxShows1" class="fromDialog" :style="$popups.popups(0.8,0.9)" :model="pagination">
                <div style="overflow: hidden; padding-bottom: 10px">
                    <el-form label-position="right" label-width="100px">
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="通道" class="EL-Form-Item">
                                <el-select v-model="pagination.whCode" filterable placeholder="请选择" clearable="clearable">
                                    <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="物料编号" class="EL-Form-Item">
                                <el-input v-model="pagination.matCode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="库位" class="EL-Form-Item">
                                <el-input v-model="pagination.laCode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="箱号" class="EL-Form-Item">
                                <el-input v-model="pagination.boxBarcode" placeholder="请输入" @change="saveSearch()">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="4" :xl="4">
                            <el-form-item class="btn-edit-delete EL-Form-Item">
                                <el-button class="btn-t-edit" @click="getOutsource()">
                                    查询
                                </el-button>
                                <el-button class="btn-t-delete" @click="resetData()">
                                    重置
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="外协单号" class="EL-Form-Item">
                                <el-input v-model="pagination.soCode" placeholder="请输入">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="状态" class="EL-Form-Item">
                                <el-select v-model="pagination.soStatus">
                                    <!-- <el-option label="进行中" value="20"></el-option> -->
                                    <el-option label="出库完成" value="30"></el-option>
                                    <!-- <el-option label="拣配完成" value="60"></el-option> -->
                                    <el-option label="收货完成" value="40"></el-option>
                                    <el-option label="关闭" value="50"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                      <el-col :lg="5" :xl="5">
                        <el-form-item label="外协供应商" class="EL-Form-Item">
                          <el-input v-model="pagination.wxCode" placeholder="请输入">
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="5" :xl="5">
                        <el-form-item label="开始日期" class="EL-Form-Item">
                          <el-date-picker v-model="pagination.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="5" :xl="5">
                        <el-form-item label="结束日期" class="EL-Form-Item">
                          <el-date-picker v-model="pagination.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-form>
                </div>
                <div class="dao"> 
                    <!-- <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="confirmReceiptCompleted()">确认收货完成</el-button>
                    <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="getOutsourceListPickShow()">拣配列表</el-button> -->
                    <el-button v-authority="'BACK_MENU6_M1_B4'" class="btn-t-edit" type="primary" @click="closeOutsourcing()">关闭外协单</el-button>
                    <!-- <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="submitMovement()">移库</el-button> -->
                 <el-button v-authority="'BACK_MENU6_M1_B6'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
               </div>
                <div>
                    <h-table :style="$popups.harvestRecordStyle(0.56)" :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal" @selectionChange="selectOutsource">
                        <el-table-column type="selection" align="center"></el-table-column>
                        <el-table-column label="外协单号" prop="soCode" align="center">
                        </el-table-column>
						<el-table-column label="外协供应商" prop="laOutsouceCode" align="center">
                        </el-table-column>
                        <el-table-column label="状态" prop="soStatus" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.soStatus == '20'">进行中</div>
                                <div v-if="scope.row.soStatus == '30'">出库完成</div>
                                <div v-if="scope.row.soStatus == '60'">拣配完成</div>
                                <div v-if="scope.row.soStatus == '40'">收货完成</div>
                                <div v-if="scope.row.soStatus == '50'">关闭</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建人" prop="person" palign="center">
                        </el-table-column>
                        <el-table-column label="创建时间" prop="createTime" align="center">
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="300px">
                            <template slot-scope="scope">
                                <el-button v-authority="'BACK_MENU6_M1_B7'" class="btn-t-edit" type="primary" @click="detailsDialogShow = true,getOutsourceDetail(scope.row.soCode,scope.row.soStatus)">详情</el-button>
                                <el-button v-authority="'BACK_MENU6_M1_B8'" class="btn-t-edit" type="primary" @click="scanOutsource(scope.row.soCode)" :disabled="scope.row.soStatus==30 ? false:true">外协接收</el-button>
                                <el-button v-authority="'BACK_MENU6_M1_B9'" class="btn-t-edit" type="primary" @click="DialogReceptionShows = true,getOutsourcePrint(scope.row.soCode)">接收记录</el-button>
                            </template>
                        </el-table-column>
                    </h-table>
                </div>
                <div slot="footer" class="dialog-footer footer-bottom">
                    <el-button size="small" type="info" @click="resetData(),editBoxShows1 = false">
                        取 消
                    </el-button>
                </div>
            </el-dialog>

            <!-- 外协详情-->
            <el-dialog title="外协详情" :visible.sync="detailsDialogShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
                <h-table :headerCellStyle="mainData.headerCellStyle" :style="$popups.harvestRecordStyle(0.75)" :data="outsourceLists" @selectionChange="checkboxDet">
                    <el-table-column label="通道" prop="whCode" align="center">
                    </el-table-column>
                    <el-table-column label="外协单号" prop="soCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="汇报完成的物料编号" prop="matCheckCode" align="center">
                    </el-table-column> -->
                    <el-table-column label="数量" prop="boxQuan" palign="center">
                    </el-table-column>
                    <el-table-column label="外协接收数量" prop="matReceiveQuan" palign="center">
                    </el-table-column>
                    <el-table-column label="批次" prop="batchNo" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="原库位" prop="laCode" align="center">
                    </el-table-column> -->
                    <el-table-column label="外协供应商" prop="laOutsouceCode" align="center">
                    </el-table-column>
                    <el-table-column label="外协报检库位" prop="laCheckCode" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column> -->
                    <!-- <el-table-column label="是否扫描确认" prop="scanFlag" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.scanFlag == false">否</div>
                            <div v-if="scope.row.scanFlag == true ">是</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="扫描接收人" prop="receivePersonNumber" palign="center">
                    </el-table-column>
                    <el-table-column label="供应商账号" prop="supplyNumber" palign="center">
                    </el-table-column> -->
                </h-table>
                <div slot="footer" class="dialog-footer footer-bottom">
                    <el-button @click="dialogClose" type="info" class="btn-t-info">关 闭</el-button>
                </div>
            </el-dialog>

            <!-- 接收记录-->
            <el-dialog title="接收记录" :visible.sync="DialogReceptionShows" class="infoDialog" :close-on-click-modal="false" :show-close="false">
              <div>
                  <el-button style="float: right"  v-authority="'XCMENUCODE'"  @click="rePrintBarcode()" class="btn-t-edit">标签打印</el-button>
             
                  <h-table :headerCellStyle="mainData.headerCellStyle" style="height: 56vh" :data="ReceptionOutsourceListss" @selectionChange="checkboxDets">
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column label="通道" prop="whCode" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="外协单号" prop="soCode" align="center">
                    </el-table-column> -->
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="数量" prop="boxQuan" palign="center">
                    </el-table-column>
                    <el-table-column label="批次" prop="batchNo" align="center">
                    </el-table-column>
                    <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column>
                    <el-table-column label="库位" prop="laCheckCode" align="center">
                    </el-table-column>
                </h-table>
              </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogCloseReceptions" type="info">取 消</el-button>
                </div>
            </el-dialog>

            <!-- 外协接收-->
            <el-dialog title="外协接收列表" :visible.sync="DialogReceptionShow" class="infoDialog" :close-on-click-modal="false" :show-close="false">
                <div style="overflow: hidden; padding-bottom: 10px">
                    <el-form label-position="right" label-width="100px">
                        <el-col :lg="5" :xl="5">
                            <el-form-item label="移入库位" class="EL-Form-Item">
                                <el-select v-model="outsourceCode" placeholder="请选择"  clearable="clearable" filterable>
                                    <el-option v-for="item in laCodeLists" :key="item.lcId" :label="item.lcCode" :value="item.lcCode">{{item.lcCode}}</el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </div>
                <h-table :headerCellStyle="mainData.headerCellStyle" style="height: 56vh" :data="ReceptionOutsourceLists" @selectionChange="checkboxDet">
                    <el-table-column type="selection" align="center" :selectable="checkboxSelectReception">
                    </el-table-column>
                    <el-table-column label="通道" prop="whCode" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="外协单号" prop="soCode" align="center">
                    </el-table-column> -->
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="数量" prop="boxQuan" palign="center">
                    </el-table-column>
                    <el-table-column label="批次" prop="batchNo" align="center">
                    </el-table-column>
                    <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column>
                    <el-table-column label="库位" prop="laCheckCode" align="center">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">

                        <el-button  class="btn-t-edit" type="primary" @click="editBoxNumShow = true,getOutsourceDetail(scope.row.soCode),(mainNum = JSON.parse(JSON.stringify(scope.row))),(oldMatQuan=JSON.parse(JSON.stringify(scope.row)).boxQuan)">修改数量</el-button>
                      </template>
                    </el-table-column>

                    <!-- <el-table-column label="是否扫描确认" prop="scanFlag" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.scanFlag == false">否</div>
                            <div v-if="scope.row.scanFlag == true ">是</div>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column label="扫描接收人" prop="receivePersonNumber" palign="center">
                    </el-table-column>
                    <el-table-column label="供应商账号" prop="supplyNumber" palign="center">
                    </el-table-column> -->
                </h-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogCloseReception" type="info">取 消</el-button>
                    <el-button @click="receiveOutSource()" type="primary">确认接收</el-button>
                </div>
            </el-dialog>

            <el-dialog title="拣配列表" :visible.sync="outsourceListPickShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
                <div>
                    <el-form label-position="right" label-width="100px">
                        <el-row>
                            <el-col :lg="5" :xl="5">
                                <el-form-item label="外协单号" class="EL-Form-Item">
                                    <el-input v-model="outsoureListSerach.operaCode" placeholder="请输入" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="5" :xl="5">
                                <el-form-item label="拣货状态" class="EL-Form-Item">
                                    <el-select v-model="outsoureListSerach.spStatus" placeholder="请选择" clearable="clearable">
                                        <!-- <el-option label="创建" value="CREATE" /> -->
                                        <el-option label="拣配中" value="EXECUTE" />
                                        <el-option label="完成" value="COMPLETE" />
                                        <el-option label="取消" value="CANCEL" />
                                        <el-option label="关闭" value="CLOSE" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="5" :xl="5">
                                <el-form-item label="开始日期" class="EL-Form-Item">
                                    <el-date-picker v-model="outsoureListSerach.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="5" :xl="5">
                                <el-form-item label="结束日期" class="EL-Form-Item">
                                    <el-date-picker v-model="outsoureListSerach.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="4" :xl="4">
                                <el-form-item class="btn-edit-delete EL-Form-Item">
                                    <el-button class="btn-t-edit" @click="getOutsourceList()">
                                        查询
                                    </el-button>
                                    <el-button class="btn-t-delete" @click="mainReset()">
                                        重置
                                    </el-button>
                                    <el-button class="btn-t-edit" @click="getPrintList()">
                                        单据打印
                                    </el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <h-table :headerCellStyle="outsourceList.headerCellStyle" :style="$popups.harvestRecordStyle(0.7)" :data="outsourceList.data" pagination :nowPage.sync="outsourceList.nowPage" :pageSize.sync="outsourceList.pageSize" :total.sync="outsourceList.total" @pageChange="getOutsourceListPickShow()" @selectionChange="checkboxMain">
                        <el-table-column type="selection" align="center"></el-table-column>
                        <el-table-column label="外协单号" prop="operaCode" align="center">
                        </el-table-column>
                        <el-table-column label="物料总数量" prop="matQuan" align="center">
                        </el-table-column>
                        <el-table-column label="实际拣货数量" align="center" prop="realPickMat">
                            <template slot-scope="scope">
                                <span>{{ scope.row.realPickMat }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="拣货状态" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.spStatus == 'CREATE'">创建</div>
                                <div v-if="scope.row.spStatus == 'EXECUTE'">拣配中</div>
                                <div v-if="scope.row.spStatus == 'COMPLETE'">完成</div>
                                <div v-if="scope.row.spStatus == 'CANCEL'">取消</div>
                                <div v-if="scope.row.spStatus == 'CLOSE'">关闭</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="拣货类型" prop="operaType" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.operaType == '10'">生产叫料</div>
                                <div v-if="scope.row.operaType == '20'">部门领用</div>
                                <div v-if="scope.row.operaType == '30'">采购退货</div>
                                <div v-if="scope.row.operaType == '60'">外协</div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="拣货单号" prop="spCode" align="center">
                        </el-table-column> -->
                        <el-table-column label="创建时间" prop="createTime" align="center">
                        </el-table-column>
                        <el-table-column label="操作人" prop="person" align="center">
                        </el-table-column>
                        <el-table-column label="操作" width="200px">
                            <template slot-scope="scope">
                                <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="detailsDialog(scope.row)" :disabled="scope.row.spStatus=='CREATE'?true:false">详情</el-button>
                            </template>
                        </el-table-column>
                    </h-table>
                </div>
                <div slot="footer" class="dialog-footer footer-bottom">
                    <el-button @click="closeOutsourceListPick" type="info" class="btn-t-info">关 闭</el-button>
                </div>
            </el-dialog>

            <!-- 拣货列表 -->
            <el-dialog title="拣货列表" :visible.sync="outsourceDetailsDialogShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
                <!-- <h-table :headerCellStyle="mainData.headerCellStyle" style="height: 56vh" @pageChange="getStockPickDetailList()" :data="detailsData.data" pagination :nowPage.sync="detailsData.nowPage" :pageSize.sync="detailsData.pageSize" :total.sync="detailsData.total" @selectionChange="checkboxDet"> -->
                <h-table :headerCellStyle="outsourceDetail.headerCellStyle" :style="$popups.harvestRecordStyle(0.75)" :data="outsourceDetail.data" :total.sync="outsourceDetail.total" @selectionChange="checkboxOutsourceDet">
                    <el-table-column type="selection" align="center" :selectable="checkboxDeatilSelect">
                    </el-table-column>
                    <!-- <el-table-column label="外协单号" prop="operaCode" align="center">
                    </el-table-column> -->
                    <!-- <el-table-column label="拣货单号" prop="spCode" align="center">
                    </el-table-column> -->
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="物料数量" prop="matQuan" align="center">
                    </el-table-column>
                    <el-table-column label="实际拣货数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="拣货扫描" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.scanFlag ? "已扫描" : "未扫描" }}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" align="center">
                        <template slot-scope="scope">
                            <div v-if="operaType=='10'">
                                <span v-if="scope.row.distrType == '10'">待配送</span>
                                <span v-if="scope.row.distrType == '20'">配送中</span>
                                <span v-if="scope.row.distrType == '30'">配送完成</span>
                                <span v-if="scope.row.distrType == '40'">关闭</span>
                            </div>
                            <div v-else>
                                <span v-if="scope.row.distrType == '40'">关闭</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="推荐库位" prop="laCodeAdvise" align="center">
                    </el-table-column>
                    <el-table-column label="实际库位" prop="laCodeReal" align="center">
                    </el-table-column>
                    <el-table-column label="规值" prop="matSpecs" align="center">
                    </el-table-column>
                    <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column>
                    <el-table-column label="创建时间" prop="createTime" align="center">
                    </el-table-column>
                    <el-table-column label="拣货操作员" prop="person" align="center">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <!-- <el-button class="btn-t-edit" type="primary" @click="laCodeReset(scope.row)" :disabled='scope.row.scanFlag?true:false'>重新推荐库位</el-button> -->
                            <el-button class="btn-t-edit" type="primary" @click="dialogOpenPD(scope.row)" :disabled="scope.row.scanFlag || operaType == '30' || scope.row.distrType == '40'?true:false">关闭</el-button>
                        </template>
                    </el-table-column>
                </h-table>
                <div slot="footer" class="dialog-footer footer-bottom">
                    <el-button @click="closeDetailDialog" type="info" class="btn-t-info">取 消</el-button>
                    <el-button @click="pickStockReturnList()" type="danger" class="btn-t-edit" :disabled='buttonShow'>确认拣货</el-button>
                </div>
            </el-dialog>

            <el-dialog title="打印" :visible.sync="printShow" width="1500px" :close-on-click-modal="false">
                <v-print :doPrint.sync="print">
                    <div id="demo" class="demo">
                        <div>
                            <div style="margin-left: -1200px; margin-top: 50px">
                                {{ timeDate }}
                            </div>
                            <div style="margin-right: -1400px; margin-top: 50px">
                                <el-button size="small" type="primary" @click="clearPrintData">
                                    清空数据
                                </el-button>
                            </div>
                            <div style="
                                font-size: 30px;
                                font-weight: 600;
                                margin-top: 20px;
                                text-align: center;
                                ">
                                {{ operaType }}发货单
                            </div>
                            <div class="div" style="margin-top: 10px; font-size: 20px">
                                <!-- <span>工序：</span> -->
                                <span>通道：{{whCodes}}</span>
                                <span>外协单号：{{mainObj.soCode}}</span>
                                <span>申请人：{{persons}}</span>
                                <span>日期：{{ timeDate }}</span>
                                <!-- <span>发货（库房）：</span> -->
                                <span>供应商：{{mainObj.laOutsouceCode}}</span>
                            </div>
                            <div class="table">
                                <table width="100%" border="1" cellpadding="0" cellspacing="0">
                                    <tr>
                                        <th></th>
                                        <th colspan="3">通道下单</th>
                                        <th colspan="4">通道接单</th>
                                        <!-- <th colspan="2">通道接料</th> -->
                                    </tr>
                                    <tr class="td">
                                        <td>序号</td>
                                        <td>型号</td>
                                        <td>规值</td>
                                        <td>数量</td>
                                        <td>实发库位</td>
                                        <td>箱号</td>
                                        <!-- <td>数量</td> -->
                                        <td>实发数量</td>
                                        <td>备注</td>
                                    </tr>
                                    <tr v-for="(item, index) in printList" :key="index">
                                        <td>{{index + 1}}</td>
                                        <td>{{item.matCode}}-{{item.matName}}</td>
                                        <td>{{ item.matSpecs }}</td>
                                        <td>{{ item.matQuan }}</td>
                                        <td>{{ item.laCodeReal }}</td>
                                        <td>{{ item.boxBarcode }}</td>
                                        <td>{{ item.matQuan }}</td> 
                                        <td></td> 
                                        <!-- <td>{{ item.matQuan }}</td> -->
                                    </tr>
                                </table>
                            </div>
                            <div class="div" style="margin-top: 10px; font-size: 20px">
                                <!-- <span>总数量：{{ summarySumNumber }}</span> -->
                                 <span>箱数：{{ boxNumber }}</span>
                                 <span style="width:100px">车间签字：</span>
                                 <span style="padding-left: 250px;">仓库签字：</span>
                                <span style="float:right;margin-right:90px">供应商签字：</span>
                            </div>
                        </div>
                    </div>
                </v-print>

                <div style="margin-top: 50px;height:80px">
                    <el-button class="btn-t-edit" @click="(printShow = false)">取消</el-button>
                    <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button>
                </div>
            </el-dialog>

            <!-- 标签打印 -->
            <el-dialog  title="标签打印" :visible.sync="labelPrintShow" width="1200px" :close-on-click-modal="false" >
              <v-print :doPrint.sync="labelPrintFlag">
                <outsource-label :data="labelPrintData" />
              </v-print>
              <div style="margin-top: 50px;height:80px;text-align: center">
                <el-button class="btn-t-edit" @click="labelPrintShow = false">取消</el-button>
                <el-button class="btn-t-edit" @click="labelPrintFlag = true,labelPrintShow = false">打印</el-button>
              </div>
            </el-dialog>

          <!-- 编辑框 -->
          <el-dialog :title="'修改数量'" width="400px"  :close-on-click-modal="false" :visible.sync="editBoxNumShow" :model="mainNum" >

            <el-form :inline="true" label-position="top" label-width="80px"  :model="mainNum"  ref="mainNum">
              <el-form-item label="数量" prop="boxQuan" style="padding-left: 100px;">
                <el-input v-model="mainNum.boxQuan" oninput="value=value.replace(/[^\d]/g,'')">
                </el-input>

              </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="editBoxNumShow=false">
                    取 消
                </el-button>

                <el-button size="small" type="primary" @click="editRow">
                    修 改
                </el-button>
            </span>
          </el-dialog>


          <el-dialog class="unpacking-dialog" title="拆包" :visible.sync="unpackDialog" width="32%" @close="NoUnpacking">
            <div style="font-size: 16px">
              <el-row type="flex" justify="space-between" style="margin: 10px;height:50px">
                <span style="height:50px;line-height:50px">原包装编号</span>
                <el-col :span="14" style="height:50px;line-height:50px">
                  <el-input v-model="unpack.boxBarcode" @keyup.enter.native="submit"></el-input>
                </el-col>
                <div style="height:50px;line-height:50px;">
                  <el-button class="btn-t-edit" @click="submit">
                    查询
                  </el-button>
                </div>
              </el-row>
              <!-- <el-row type="flex" justify="space-between" style="margin: 10px">
                  <span>新包装编码</span>
                  <el-col :span="14">
                      <el-input :disabled="true" placeholder="确认后自动生成"> </el-input>
                  </el-col>
              </el-row> -->
              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>通道编号</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.whCode
                  }}</span>
              </el-row>
              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>工厂编号</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.fcCode
                  }}</span>
              </el-row>
              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>物料编号</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.matCode
                  }}</span>
              </el-row>
              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>物料描述</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.matName
                  }}</span>
              </el-row>
              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>批次号</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.batchNo
                  }}</span>
              </el-row>
              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>物料状态</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.wiStatus=='NORMAL'?'正常':unpackDate.wiStatus=='FREEZE'?'拣配中':unpackDate.wiStatus=='DELETE'?'作废':unpackDate.wiStatus=='OVERTIME'?'过期':unpackDate.wiStatus=='AGFREEZE'?'人工冻结':''
                  }}</span>
              </el-row>

              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>库位编号</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.lcCode
                  }}</span>
              </el-row>

              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>入库时间</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.matCreateTime
                  }}</span>
              </el-row>
              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>规值</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.matSpecs
                  }}</span>
              </el-row>
              <!-- <el-row type="flex" justify="space-between" style="margin: 10px">
                  <span>更新时间</span>
                  <span style="color: #1f6cec">{{
          unpackDate && unpackDate.updateTime
        }}</span>
              </el-row> -->
              <el-row type="flex" justify="space-between" style="margin: 10px">
                <span>数量</span>
                <span style="color: #1f6cec">{{
                    unpackDate && unpackDate.matQuan
                  }}</span>
              </el-row>
              <br />
              <el-divider></el-divider>
              <br />
              <el-row type="flex" justify="space-between" align="middle">
                <!-- <span style="width:100px">新包装位置</span> -->
                <!-- <el-col :span="20">
                    <el-cascader :key="keyValue" v-model="lcCodeType" :options="inventoryLocationList" :props="optionProps" collapse-tags clearable style="width:280px">
                    </el-cascader>
                </el-col> -->
                <span style="width:100px">新包装货位</span>
                <el-col :span="24">
                  <!-- <el-form-item label="移入货位"> -->
                  <el-select v-model="lcCodeByLcType" placeholder="请选择" @change="getLcCodeIsCorrect()" filterable remote :remote-method="remoteMethodLcCode">
                    <el-option v-for="(item, index) in lcCodeByLcTypeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                    </el-option>
                  </el-select>
                  <!-- </el-form-item> -->
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle" style="margin:10px 10px">
                <span>每箱数量</span>
                <el-col :span="20">
                  <el-input-number v-model="boxNumber" :min="0" label="描述文字"></el-input-number>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle" style="margin:10px 10px">
                <span>拆分箱数</span>
                <el-col :span="20">
                  <el-input-number v-model="boxCount" :min="1" label="描述文字"></el-input-number>
                </el-col>
              </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="NoUnpacking" class="btn-t-info">取 消</el-button>
                <el-button :loading="unpackings" class="btn-t-edit" @click="unpacking">确 定</el-button>
            </span>
          </el-dialog>

        </box>
    </div>
</template>

<script>
    import printJS from "print-js";
    import vPrint from 'syl-vue-printer'
    import htmlToPdf from "@/libs/htmlToPdf";
    import OutsourceLabel from "@/views/printPages/outsource-label";
    import moment from "moment";
    export default {
        name: "Outsource",
        components: {
          OutsourceLabel,
            vPrint
        },
        data() {
            return {
                 /* 首页显示的数据 */
                mainSearch: {
                    query: {
                        fcCode: localStorage.getItem("fcCode") || "",
                        lcCode: "",
                        whCode: "",
                        matCode: "",
                        matName: "",
                        batchNo: "",
                        boxBarcode: "",
                        checkResult:"20",
                        date: [],
                    },
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    data: [],
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
               unpackings: false,
               qualityLists:[],
              unpack: {
                // 拆分的数量
                // 原包装编码 BX2021100800004 XZP000150IM-3024430007
                boxBarcode: "",
                // 工厂编号
                fcCode: "",
                // 批次号
                batchNo: "",
                // 物料数量
                matQuan: "",
                // 物料描述
                matName: "",
                // 物料编号
                matCode: "",
                // 更新的时间
                updateTime: "",
                // 创建的时间
                createTime: "",
                // 库位编号
                lcCode: "",
                mtUnit: "",
              },
              //新包装位置
              lcCodeType: [],
              //新包装的货位号
              newLcCode: "",
              // 拆包的数据
              unpackDate: "",
              //拆包数量
              boxNumbern: "0",
              //拆包箱数
              boxCount: "1",
               oldMatQuan:"",
               editBoxNumShow:false,
                // 库区集合
                WhCodeList: [],
                lcCodeByLcTypeList:[],
                // 库位集合
                lcCodeList: [],
                form: {},
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    soCode: "",
                    boxBarcode: "",
                    matCode: "",
                    person: "",
                    soStatus: "",
                    whCode: "",
                    laCode: "",
                    wxCode:"",
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: [],
                    date:[],
                },
              mainNum:{
                nowNum:"",
              },
				tableTotal: 0,
            // 库位选择
            laCodeLists: [],
                warehouseList: [],
                mainObj: {
                    soCode: "",
                    laOutsouceCode: "",
                    boxBarcode: ""
                },
                rules: {

                    laOutsouceCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    boxBarcode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },
                outsourceLists: [],

                addOutsourceLists:[],
                detailsDialogShow: false,
                ReceptionOutsourceLists: [],
                ReceptionOutsourceListss:[],
                DialogReceptionShow: false,
                DialogReceptionShows:false,

                laCodeList: [],
                checkOutsourceList: [], //多选
                checkOutsourceLists: [], //多选
                checkListDet: [],
                checkListDets:[],

                editBoxShow: false,
                editBoxShows:false,
                editBoxShowss:false,
                //移入货位
                lcCodeByLcType: "",
                //货位号判断
                lcCodeFlag: false,
                unpackDialog:false,

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                //外协移库位置
                outsourceCode: '',

                //拣配列表窗口
                outsourceListPickShow: false,
                //外协集合
                outsourceList:{
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    data: [],
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //外协查询条件
                outsoureListSerach:{
                    fcCode: localStorage.getItem("fcCode") || "",
                    operaCode: "",
                    spStatus:"",
                    operaType:"60",
                    date: [],
                },
                //外协拣配窗口
                outsourceDetailsDialogShow:false,
                //外协明细数据
                outsourceDetail:{
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    data: [],
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },    
                },
                //判断拣货单是查看还是拣配
                buttonShow: false,
                checkList:[],
                checkDetail:[],
                //单据打印文字
                operaType:"",
                //单据打印的数据
                spIdList:[],
                //单据打印存放数据
                printList:[],
                //单据打印窗口
                printShow:false,
                //单据打印时间
                timeDate: new Date(),
                //存放通道签字
                whCodes:"",
                printObj: {
                    id: "demo",
                    popTitle: "",
                },
                print: false,
                //汇总对象
                SummaryData:{},
                //总数量
                sumNumber:0,
                //汇总总数量
                summarySumNumber: 0,
                //总箱数
                boxNumber:0,
                persons: localStorage.getItem("userName"),
                printsList:[],
                editBoxShows1:false,
                // 标签打印
                labelPrintShow: false,
                labelPrintFlag: false,
                labelPrintData: null
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getOutsource(newVal);
                    },1000)
                },
                deep: true,
            },
            "mainSearch.query": {
                handler() {
                    clearTimeout(this.isSetTimeout);
                    this.isSetTimeout = setTimeout(() => {
                        this.getTableData();
                    }, 1000);
                },
                deep: true,
            },
            "mainSearcRecord.query": {
                handler() {
                    clearTimeout(this.isSetTimeout);
                    this.isSetTimeout = setTimeout(() => {
                        this.getOtherRecordList();
                    }, 1000);
                },
                deep: true,
            },
            "mainObj.query": {
                handler() {
                    // clearTimeout(this.isSetTimeout);
                    // this.isSetTimeout = setTimeout(() => {
                    //     if (!this.putInMotionData.length) {
                    //         this.getWhData();
                    //     }
                    // }, 1000);
                },
                deep: true,
            },
        },
        computed: {
             startPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.query.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.query.date[1]);
                        }
                    },
                };
            },
            finishPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.query.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.query.date[0]);
                        }
                    },
                };
            },
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.outsoureListSerach.date[0]) {
                            return time.getTime() < new Date(_this.outsoureListSerach.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.outsoureListSerach.date[1]) {
                            return time.getTime() > new Date(_this.outsoureListSerach.date[1]);
                        }
                    }
                }
            },
        },
        methods: {

          //表单验证
          submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
              if (valid) {
                r = true;
              } else {
                r = false;
              }
            });
            return r;
          },
          //编辑
          editRow() {
            if (this.submitForm("mainNum")) {
              if(this.mainNum.boxQuan == 0){
                this.$message({
                  type: "warning",
                  message: "数量不能为0！",
                });
                return
              }
              if(this.oldMatQuan<this.mainNum.boxQuan){
                this.$message({
                  type: "warning",
                  message: "不能大于当前数量！",
                });
                return
              }
              if(this.oldMatQuan==this.mainNum.boxQuan){
                this.$message({
                  type: "warning",
                  message: "修改的数量不能一样！",
                });
                return
              }
              this.$http
                  .request({
                    url: "/api/outsource/updateBoxQuanReceive",
                    method: "POST",
                    showLoading: true,
                    data: this.mainNum,
                    params: {
                      person: localStorage.getItem("user"),
                      personNumber: localStorage.getItem("empNumber"),
                    }
                  })
                  .then((resp) => {
                    if (resp.status == 100) {
                      this.$notify({
                        title: "成功",
                        message: "修改成功！",
                        type: "success",
                      });
                      this.logRemarks = "outsource：修改成功为："+this.mainNum.boxQuan;
                      this.editBoxNumShow = false;
                    } else {
                      this.$notify.error({
                        title: "失败",
                        message: resp.message,
                      });
                      this.logRemarks = "outsource：修改失败"+this.mainNum.boxQuan;
                    }
                    this.logContent = "boxQuan：" + this.mainNum.boxQuan;
                    this.systemLog();
                    this.scanOutsource(this.mainNum.soCode);
                  })
                  .catch((error) => {
                    this.$notify.error({
                      title: "失败",
                      message: "调用失败",
                    });
                  });
            }
          },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getOutsource()
                }, 1000)
            },

            handleDown() {
                // console.log(document.querySelector("#demo"));
                htmlToPdf.downloadPDF(document.querySelector("#demo"), "X-R控制图");
            },

            // 打开外协移库窗口
            openOutsourceTransfer(){
                this.pagination.soStatus = "20,80,90"
                this.editBoxShows = true;
            },

            // 打开外协接收窗口
            openOutsourceReceiving(){
                this.pagination.soStatus = "30"
                this.editBoxShows1 = true;
            },

            // 确认收货完成
            confirmReceiptCompleted(){
                this.$http
                    .request({
                        url: "/api/outsource/confirmReceiptCompleted",
                        method: "GET",
                        params: {
                            spId: spId || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.outsourceDetail.data = resp.data.list || [];
                            this.outsourceDetail.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /* 获取外协拣配数据 */
            getOutsourceListPickShow(){
                this.getOutsourceList();
                this.outsourceListPickShow = true;
            },

            /**
             * 多选
             */
            checkboxMain(val) {
                this.checkList = val;
            },
            checkboxOutsourceDet(val) {
                this.checkDetail = val;
            },
            //禁选
            checkboxDeatilSelect(row, rowIndex) {
                if (row.scanFlag || row.distrType == '40') {
                    return false; // 禁用
                } else {
                    return true; // 不禁用
                }
            },

            /**
             * 详情
             */
            detailsDialog(row) {
                if (row.spStatus == 'EXECUTE') {
                    this.buttonShow = false;
                } else {
                    this.buttonShow = true;
                }
                this.operaType = row.operaType;
                this.outsourceDetail.data = [];
                this.outsourceDetailsDialogShow = true;
                this.getStockPickDetailList(row.spId);
                this.spId = row.spId;
            },

            /**
             * 获取当前时间
             * 格式YYYY-MM-DD
             */
            getTime() {
                var date = new Date();
                var seperator1 = "/";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                this.timeDate = year + seperator1 + month + seperator1 + strDate;
            },

            //清空打印数据
            clearPrintData(){
                this.printList = [];
                this.summarySumNumber = 0;
                this.sumNumber = 0;
                this.boxNumber = 0;
                this.whCodes = "";
            },

            /**
             * 查询拣货单详情记录
             */
            getStockPickDetailList(spId) {
                this.$http
                    .request({
                        url: "/api/order/getStockPickDetailList",
                        method: "GET",
                        params: {
                            // pageNum: this.detailsData.nowPage,
                            // pageSize: this.detailsData.pageSize,
                            spId: spId || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.outsourceDetail.data = resp.data.list || [];
                            this.outsourceDetail.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            getPrintList() {
                if(this.checkList.length == 0){
                    this.printShow = true;
                }else{
                    var code = 0;
                    var whCode = this.checkList[0].whCode;
                    this.checkList.forEach((item) => {
                        if(this.spIdList.indexOf(item.spId) < 0){
                            this.spIdList.push(item.spId);
                        }
                        
                    })

                    var spId = this.spIdList.join(",")

                    if(this.checkList[0].operaType == "10"){
                        this.operaType = "叫料"
                    }else if(this.checkList[0].operaType == "20"){
                        this.operaType = "部门领用"
                    }else if(this.checkList[0].operaType == "30"){
                        this.operaType = "采购退货"    
                    }else if(this.checkList[0].operaType == "50"){
                        this.operaType = "冻结"    
                    }else if(this.checkList[0].operaType == "60"){
                        this.operaType = "外协"    
                    }
                    this.whCodes = whCode;
                    //this.printShow = true;
                    this.$http
                        .request({
                            url: "/api/order/getStockPickDetailList",
                            method: "GET",
                            params: {
                                pageNum: 0,
                                pageSize: 0,
                                spId: spId || null,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                if (resp.data.list != null) {
                                    this.printsList = resp.data.list;
                                    var matCode = resp.data.list[0].matCode || "";
                                    this.printList = [];
                                    this.summarySumNumber = 0;
                                    this.sumNumber = 0;
                                    this.printsList.forEach((item,index)=>{
                                        if(matCode == item.matCode){
                                            this.sumNumber += item.matQuan;
                                            this.printList.push(item);
                                        }else{
                                            this.printList.push({matQuan:this.sumNumber});
                                            this.printList.push(item)
                                            matCode = item.matCode;
                                            this.summarySumNumber += this.sumNumber;
                                            this.sumNumber = item.matQuan;
                                        }
                                    })
                                    console.log(this.printList);
                                    this.printList.push({matQuan:this.sumNumber})
                                    this.summarySumNumber += this.sumNumber;
                                    this.boxNumber = resp.data.total;
                                    this.printShow = true;
                                } else {
                                    this.$message({
                                        message: "未找到拣货详情打印记录！",
                                        type: "warning",
                                    });
                                }
                            }
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                }
                
            },

            // 关闭外协详情
            closeDetailDialog(){
                this.outsourceDetailsDialogShow = false;
                this.getOutsourceList();
            },

            //关闭拣货详情
            dialogOpenPD(row) {
                this.closeObj = row;
                this.closePickDShow = true;
            },

            /**
             * 拣货记录-确认拣货
             */
            pickStockReturnList() {
                if (this.checkDetail.length == 0) {
                    this.$message({
                        message: "请先勾选记录！",
                        type: "warning",
                    });
                    return;
                }
                this.$confirm("是否确认拣货?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/pickStockReturnList/" +
                                    localStorage.getItem("user"),
                                method: "POST",
                                showLoading: true,
                                data: this.checkDetail,
                                params: {
                                    personNumber: localStorage.getItem("empNumber") || null,
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：确认拣货成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：确认拣货失败";
                                }
                                this.logContent = JSON.stringify(this.checkListDet);
                                this.systemLog();
                                //刷新数据
                                this.dialogClose();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消收货",
                        });
                    });
            },

            /**
             * 查询拣货单记录
             */
            getOutsourceList() {
              var dTime = moment().subtract(1, 'month').format("YYYY-MM-DD HH:mm:ss");
                this.$http
                    .request({
                        url: "/api/order/getStockPickPageList",
                        method: "GET",
                        params: {
                            fcCode: this.outsoureListSerach.fcCode || null,
                            spStatus: this.outsoureListSerach.spStatus || null,
                            operaType: this.outsoureListSerach.operaType || null,
                            operaCode: this.outsoureListSerach.operaCode || null,
                            beginTime: dTime,
                            //endTime: this.outsoureListSerach.date ? this.outsoureListSerach.date[1] : null,
                            pageNum: this.outsourceList.pageNum,
                            pageSize: this.outsourceList.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.checkList = resp.data.list || [];
                            //打印外协单
                            this.getPrintListOut();
                            //this.outsourceList.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            // 关闭外协拣配列表窗口
            closeOutsourceListPick(){
                this.outsourceListPickShow = false;
            },

             /* 获取首页的数据 */
            getTableData() {
                this.$http
                    .request({
                        url: "/api/order/getStockList",
                        method: "GET",
                        params: {
                            fcCode: this.mainSearch.query.fcCode || null,
                            whCode: this.mainSearch.query.whCode || null,
                            matCode: this.mainSearch.query.matCode || null,
                            matName: this.mainSearch.query.matName || null,
                            batchNo: this.mainSearch.query.batchNo || null,
                            boxBarcode: this.mainSearch.query.boxBarcode || null,
                            lcCode: this.mainSearch.query.lcCode || null,
                            beginTime: this.mainSearch.query.date ?
                                this.mainSearch.query.date[0] : null,
                            endTime: this.mainSearch.query.date ?
                                this.mainSearch.query.date[1] : null,
                            pageNum: this.mainSearch.pageNum,
                            pageSize: this.mainSearch.pageSize,
                            checkResult:this.mainSearch.query.checkResult || null,
                            syncXa:0,
                            saleFlag:0,
                            lcType:'RET,JMFO,CKJW03'
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainSearch.data = res.data.list || [];
                            this.mainSearch.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    })
                    .catch((error) => {
                        this.$message.error("错误");
                    });
            },
            //获取数据
            getOutsource: function() {
                this.$http
                    .request({
                        url: "/api/outsource/getOutsourceData",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum || null,
                            pageSize: this.pagination.pageSize || null,
                            soCode: this.pagination.soCode || null,
                            matCode: this.pagination.matCode || null,
                            boxBarcode: this.pagination.boxBarcode || null,
                            fcCode: this.pagination.fcCode || null,
                            person: this.pagination.person || null,
                            laCode: this.pagination.laCode || null,
                            whCode: this.pagination.whCode || null,
                            soStatus: this.pagination.soStatus || null,
                            wxCode: this.pagination.wxCode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.tableTotal = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            //关闭外协单
            closeOutsourcing() {
                if (this.checkOutsourceList.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "请选择外协单！",
                    });
                    return
                }
                const res = this.checkOutsourceList.every(e => {
                    if (e.soStatus == "40" || e.soStatus == "50") {
                        this.$message({
                            type: "warning",
                            message: "未移库状态下的外协单才能关闭！",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }

                this.$confirm("是否关闭该外协单? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/closeOutsourcing",
                                method: "POST",
                                data: this.checkOutsourceList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                }
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "操作成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "outsource：关闭外协单成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: res.message,
                                    });
                                    this.logContent = JSON.stringify(this.checkOutsourceList);
                                    this.systemLog();
                                    this.logRemarks = "outsource：关闭外协单成功";
                                }
                                this.getOutsource();
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            //新增数据
            insertOutsource() {
                if (this.checkOutsourceLists.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "请选择要新增的数据！",
                    });
                    return
                }
                // if(this.mainObj.soCode == null || this.mainObj.soCode == ""){
                //      this.$message({
                //         type: "warning",
                //         message: "外协单号不能为空！",
                //     });
                //     return
                // }
                if(this.mainObj.soCode.length > 10){
                     this.$message({
                        type: "warning",
                        message: "外协单号长度不能超过十位数！",
                    });
                    return
                }
                if(this.mainObj.laOutsouceCode == null || this.mainObj.laOutsouceCode == ""){
                     this.$message({
                        type: "warning",
                        message: "外协库位不能为空！",
                    });
                    return
                }

                this.$confirm("是否新增，并提交拣配? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/insertOutsourceList",
                                method: "POST",
                                showLoading: true,
                                data: this.checkOutsourceLists,
                                params: {
                                    person: localStorage.getItem("user") || null,
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    fcCode: localStorage.getItem("fcCode") || null,
                                    soCode: this.mainObj.soCode,
                                    laOutsouceCode: this.mainObj.laOutsouceCode
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        type: "success",
                                        message: "新增成功！",
                                    });
                                    var soCode = this.mainObj.soCode;
                                    this.editBoxShow = false;
                                    this.getOutsource();
                                    this.logRemarks = "outsource：新增外协记录成功";
                                    //this.clearOutsource();

                                    this.checkOutsourceLists = [];
                                    this.mainObj.soCode = resp.data
                                    //根据外协单查询拣配信息
                                    this.outsoureListSerach.operaCode = resp.data;
                                    this.getOutsourceList();
                                    
                                } else {
                                    this.$message({
                                        type: "warning",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "outsource：新增外协记录失败";
                                }
                                this.logContent = JSON.stringify(this.addOutsourceLists);
                                this.systemLog();
                                //this.clearOutsource();
                            })
                            .catch((error) => {
                                this.loading++;
                            });

                    })
                
            },

            //根据外协单查询

            getPrintListOut() {
                if(this.checkList.length == 0){
                    this.printShow = true;
                }else{
                    var code = 0;
                    var whCode = this.checkList[0].whCode;

                    if(this.checkList[0].operaType == "10"){
                        this.operaType = "叫料"
                    }else if(this.checkList[0].operaType == "20"){
                        this.operaType = "部门领用"
                    }else if(this.checkList[0].operaType == "30"){
                        this.operaType = "采购退货"    
                    }else if(this.checkList[0].operaType == "50"){
                        this.operaType = "冻结"    
                    }else if(this.checkList[0].operaType == "60"){
                        this.operaType = "外协"    
                    }
                    this.whCodes = whCode;
                    console.log(1);
                    //this.printShow = true;
                    this.$http
                        .request({
                            url: "/api/order/getStockPickDetailList",
                            method: "GET",
                            params: {
                                pageNum: 0,
                                pageSize: 0,
                                spId: this.checkList[0].spId || null,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                if (resp.data.list != null) {
                                    this.printsList = resp.data.list;
                                    var matCode = resp.data.list[0].matCode || "";
                                    this.printList = [];
                                    this.summarySumNumber = 0;
                                    this.sumNumber = 0;
                                    this.printsList.forEach((item,index)=>{
                                        if(matCode == item.matCode){
                                            this.sumNumber += item.matQuan;
                                            this.printList.push(item);
                                        }else{
                                            this.printList.push({matQuan:this.sumNumber});
                                            this.printList.push(item)
                                            matCode = item.matCode;
                                            this.summarySumNumber += this.sumNumber;
                                            this.sumNumber = item.matQuan;
                                        }
                                    })
                                    this.printList.push({matQuan:this.sumNumber})
                                    this.summarySumNumber += this.sumNumber;
                                    this.boxNumber = resp.data.total;
                                    this.printShow = true;
                                } else {
                                    this.$message({
                                        message: "未找到拣货详情打印记录！",
                                        type: "warning",
                                    });
                                }
                            }
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                }
                
            },

            //多选
            selectOutsource(val) {
                this.checkOutsourceList = val;
            },
            Outsourcrecord(){
				//this.addOutsourceLists=[]; //初始化
                if(this.checkOutsourceList.length == 0){
                    this.$message({
                        type: "warning",
                        message: "请选择外协单！",
                    });
                    return
                }
                const res = this.checkOutsourceList.every(e => {
                    if (e.wiStatus != "NORMAL") {
                        this.$message({
                            message: "请选择库存状态正常的数据",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.addOutsourceLists.push(...this.checkOutsourceList);
                //数组集合中清除相同对象
                for(var i=0; i<this.addOutsourceLists.length; i++){
                    var item = this.addOutsourceLists[i]
                    for(var j = i+1; j<this.addOutsourceLists.length; j++){
                        if(item == this.addOutsourceLists[j]){
                            this.addOutsourceLists.splice(j,1)
                            i--
                        }                          
                    }
                };
                this.editBoxShow = true;
                this.getlaCode()
            },
            //删除获取的库存
            deletelist(row){
                for(var i = 0; i < this.addOutsourceLists.length; i++){
                    if(this.addOutsourceLists[i].wiId === row.wiId){
                        this.addOutsourceLists.splice(i,1);
                    }
                }
            },

            //多选
            selectOutsources(val) {
                this.checkOutsourceLists = val;
            },
            //禁选
            checkboxSelect(row, rowIndex) {
                if (row.soStatus == "10") {
                    return true; // 不禁用
                } else {
                    return false; // 禁用
                }
            },
            checkboxDet(val) {
                this.checkListDet = val;
            },
            checkboxDets(val) {
                this.checkListDets = val;
            },

             /* 获取所有的库位 */
            getSysLocationAll(lcCode) {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcCode: lcCode || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lcCodeList = resp.data.list;
                            this.lcCodeByLcTypeList = resp.data.list;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /* 远程搜索库位号 */
            remoteMethodLcCode(query) {
                if (query || query == 0) {
                    // this.lcCodeLoading = true;
                    this.getSysLocationAll(query);
                    setTimeout(() => {
                        // this.lcCodeLoading = false;
                        if (this.lcCodeList != undefined) {
                            this.lcCodeList = this.lcCodeList.filter((item) => {
                                return (
                                    item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1
                                );
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeList = [];
                }
            },
            /* 获取所有的通道(根据用户工厂) */
            getSysWarehouseAll() {
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getSysWarehouseAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.WhCodeList = resp.data;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /* 所有查询的点击事件 */
            inquireDataClick(type) {
                if (type == "mainSearch") {
                    this.mainSearch.pageNum = 1;
                    this.getTableData();
                }
            },
            /* 所有重置的点击事件 */
            resetClick() {
                this.mainSearch.query = {
                        fcCode: localStorage.getItem("fcCode") || "",
                        lcCode: "",
                        whCode: "",
                        matCode: "",
                        matName: "",
                        batchNo: "",
                        boxBarcode: "",
                        date: [],
                    };
            },
            //提交进行移库
            submitMovement() {
                if (this.checkOutsourceList.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "请选择外协单！",
                    });
                    return
                }
                const res = this.checkOutsourceList.every(e => {
                    if (e.soStatus != "60") {
                        this.$message({
                            type: "warning",
                            message: "拣配完成之后才能进行提交移库！",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }

                this.$confirm("是否提交进行移库操作? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/submitMovement",
                                method: "POST",
                        showLoading: true,
                                data: this.checkOutsourceList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                }
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "操作成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "outsource：提交外协单移库成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: res.message,
                                    });
                                    this.logContent = JSON.stringify(this.checkOutsourceList);
                                    this.systemLog();
                                    this.logRemarks = "outsource：提交外协单移库成功";
                                }
                                this.getOutsource();
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            //接收记录
            getOutsourcePrint(soCode){
                 this.$http
                    .request({
                        url: "/api/outsource/getOutsourcePrint",
                        method: "GET",
                        params: {
                            soCode: soCode,
                            scanFlag: true
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.ReceptionOutsourceListss = resp.data || [];
                        }
                    })
                    .catch((error) => {});
                this.DialogReceptionShows = true
            },
            //外协接收
            scanOutsource(soCode) {
                this.getlaCodes();
                this.$http
                    .request({
                        url: "/api/outsource/getOutsourcePrint",
                        method: "GET",
                        params: {
                            soCode: soCode
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.ReceptionOutsourceLists = resp.data || [];
                        }
                    })
                    .catch((error) => {});
                this.DialogReceptionShow = true
            },
            // 禁选
            checkboxSelectReception(row, rowIndex) {
                if (row.scanFlag == true) {
                    return false; // 禁用
                } else {
                    return true; // 不禁用
                }
            },
            //扫描取消
            dialogCloseReception() {
                this.DialogReceptionShow = false;
                this.ReceptionOutsourceLists = [];
            },
            //扫描取消
            dialogCloseReceptions() {
                this.DialogReceptionShows = false;
                this.ReceptionOutsourceListss = [];
            },
            //确认扫描
            receiveOutSource() {
                if (this.checkListDet.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "请勾选记录！",
                    });
                    return
                }
                if (this.outsourceCode == '') {
                    this.$message({
                        type: "warning",
                        message: "请选择移入库位",
                    });
                    return
                }
                this.$confirm("是否确认扫描操作? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/receiveOutSource",
                                method: "POST",
                                showLoading: true,
                                data: this.checkListDet,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                    outsourceCode: this.outsourceCode,
                                }
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "操作成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "outsource：确认扫描成功";
                                    this.scanOutsource(this.checkListDet[0].soCode);
                                    //this.dialogCloseReception();
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: res.message,
                                    });
                                    this.logContent = JSON.stringify(this.checkListDet);
                                    this.systemLog();
                                    this.logRemarks = "outsource：确认扫描成功";
                                }
                                this.getOutsource();
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });

            },
            //扫描取消
            dialogClose() {
                this.detailsDialogShow = false;
                this.outsourceLists = [];
                this.getOutsource();
            },

            /* 获取所有库位 */
        getlaCodes() {
            this.$http
                .request({
                    url: "/api/location/getLocationAll",
                    method: "GET",
                    params: {
                        fcCode: localStorage.getItem("fcCode") || "",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.laCodeLists = resp.data.list || [];
                    }
                })
        },

            //获取详情
            getOutsourceDetail(soCode,status) {
                this.$http
                    .request({
                        url: "/api/outsource/getOutsourceDetail",
                        method: "GET",
                        params: {
                            soCode: soCode || null,
                            statusList:status || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.outsourceLists = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },


            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    soCode: "",
                    boxBarcode: "",
                    matCode: "",
                    person: "",
                    soStatus: "",
                    whCode: "",
                    laCode: "",
                    wxCode:"",
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: [],
                    date:[],
                };
				this.tableTotal=0;
                // this.getOutsource();
            },
            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/checkTask/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.warehouseList = res.data;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //获取WX库位
            getlaCode() {
                this.$http
                    .request({
                        url: "/api/location/getLocationAll",
                        method: "GET",
                        params: {
                            lcType: "WX",
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.laCodeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //表格导出
            downLoadFile() {
               this.downloadLoading = true;
               let soCode = "";
                this.mainData.forEach((element) => {
                    if(soCode.indexOf(element.soCode) == -1){
                        soCode = soCode + element.soCode + ",";
                    }
                });
                this.$http
                    .request({
                        url: "/api/outsource/getOutsourceDetail",
                        method: "GET",
                        params: {
                            soCode: soCode || null,
                        },
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['通道', '外协单号', '物料编号', '物料描述', '汇报完成的物料编号', '箱数','接收数量', '批次', '外协库位','外协报检库位', '箱号',
                         '操作人', '工号', '更新时间', '创建时间'
                    ]
                    const filterVal = ['whCode', 'soCode', 'matCode', 'matName','matCheckCode',  'boxQuan','matReceiveQuan', 'batchNo',  'laOutsouceCode', 'laCheckCode', 'boxBarcode',
                        'person', 'personNumber', 'updateTime', 'createTime'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '外协记录数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_outsource：导出外协记录数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/checkTask/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.warehouseList = res.data;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //获取WX库位
            getlaCode() {
                this.$http
                    .request({
                        url: "/api/location/getLocationAll",
                        method: "GET",
                        params: {
                            lcType: "WX",
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.laCodeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "外协",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },


                         //标签打印
            rePrintBarcode() {
                if (this.checkListDets.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.checkListDets.forEach((item) => {

                        // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                        var produceTime = moment(item.createTime).format("YYYYMMDD");

                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                        //     "/" + produceTime + "/" + item.boxHeight + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.batchNo + "," + produceTime + ",,,,";

                        if (item.matSpecs == undefined) {
                            item.matSpecs = "";
                        }

                        var person = localStorage.getItem("user");
                        if (person != undefined && person != '') {
                            person = item.consignee;
                        }



                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxBarcode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.batchNo,
                            count: item.matQuan,
                            checkPerson: person,
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: "",
                            printTime: printTime,
                            isSta: false,
                            printTwo: false,
                            location: item.lcCode
                        }

                        this.$printer.printWMSBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },
          /**
           * 处理获取所有的货位号
           */
          getInventoryByLcCode() {
            this.newLcCode = this.lcCodeType[this.lcCodeType.length - 1]
          },
          //拆包
          unpacking() {
            this.getInventoryByLcCode();
            //判断是否输入了正确的箱号
            if (this.unpackDate == "") {
              this.$message({
                message: "请输入正确的箱号进行拆包！",
                type: "warning",
              });
              return;
            } else if (this.boxNumber == 0) {
              this.$message({
                message: "拆包数量不能为0！",
                type: "warning",
              });
              return;
            } else if (this.boxNumber >= this.unpackDate.matQuan) {
              this.$message({
                message: "拆包数量超过了原包箱数量！",
                type: "warning",
              });
              return;
            } else if (this.lcCodeByLcType == "" || this.lcCodeByLcType == undefined) {
              this.$message({
                message: "请选择新包装的库位编号！",
                type: "warning",
              });
              return;
            } else if (this.unpackDate.wiStatus == "FREEZE") {
              this.$message({
                message: "不能对拣货冻结的物料进行拆包！",
                type: "warning",
              });
              return;
            } else {
              //进行拆包
              this.$confirm("提交并打印拆包标签", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                  .then(() => {
                    this.unpackings = true;
                    this.$http
                        .request({
                          url: "/api/SplitMergeMatChange/insertStockSplit",
                          method: "POST",
                          showLoading: true,
                          params: {
                            newLcCode: this.lcCodeByLcType, //包装新货位号
                            boxNumber: this.boxNumber, // 拆包数量
                            boxCount: this.boxCount,    //拆包箱数
                            person: this.person, //拆包操作人
                            personNumber: this.personNumber, //拆包操作人工号
                          },
                          data: this.unpack,
                        })
                        .then((res) => {
                          this.logContent =
                              "boxBarcode：" +
                              this.unpack.boxBarcode +
                              "\t" +
                              "boxNumber：" +
                              this.boxNumber;
                          if (res.status == 100) {
                            //this.mainData.data = res.data.list;
                            //this.mainData.total = res.data.total;
                            this.unpackDialog = false;
                            this.boxNumber = "0";
                            this.boxCount = "1";
                            this.lcCodeByLcType = "";
                            this.$message({
                              message: "拆包成功!",
                              type: "success",
                            });

                            this.clickSelectTableData();

                            // 打印（新增拆包后获取最新一条拆包的库存记录）
                            this.topOneSplitMergeMatChange(res.data);
                            this.logRemarks = "splitMergeMatChange：拆包操作成功";

                          } else {
                            this.$message({
                              message: res.message,
                              type: "error",
                            });
                            this.logRemarks = "splitMergeMatChange：拆包操作失败";
                          }
                          this.unpackings = false;
                          this.logContent = JSON.stringify(this.unpack) + '\t' + 'boxNumber：' + this.boxNumber
                          this.systemLog();
                          alert(1)
                          this.getTableData();
                        });
                  })
                  .catch(() => {
                    this.unpackings = false;
                    this.$message({
                      type: "info",
                      message: "已取消拆包和打印",
                    });
                  });
            }
          },
          showUnpackingDialog() {
            if (this.checkOutsourceList.length != 1) {
              this.$message({
                message: "请选择一条库存数据进行拆包！",
                type: "warning",
              });
              return;
            }
            if (this.checkOutsourceList[0].lcCode.indexOf('RET')==-1) {
              this.$message({
                message: "请选择RET数据拆包！",
                type: "warning",
              });
              return;
            }
            this.getLmIdByFccode();
            this.getSysLocationAll();
            //this.unpack = {};
            //this.unpackDate = "";
            this.unpack.boxBarcode = this.checkOutsourceList[0].boxBarcode;
            this.submit();
            this.unpackDialog = true;
          },
          //取消拆包
          NoUnpacking() {
            this.unpackDialog = false;
            this.unpack = {
              boxBarcode: "",
              fcCode: "",
              batchNo: "",
              matQuan: "",
              matName: "",
              matCode: "",
              updateTime: "",
              createTime: "",
              lcCode: "",
              mtUnit: "",
            },
                this.unpackDate = "";
            this.boxNumbern = "0";
            this.boxCount = "1"
            this.inventoryLocationList = [];
            this.lcCodeType = [];
            this.lcCodeByLcType = "";
          },
          //拆包回车查询库存
          submit() {
            this.$http
                .request({
                  url: "/api/SplitMergeMatChange/getStockByBoxBarcode",
                  method: "GET",
                  params: {
                    boxBarcode: this.unpack.boxBarcode,
                  },
                })
                .then((resp) => {
                  if (resp.status == 100) {
                    if (resp.data.list[0].matQuan == 1) {
                      this.$message({
                        message: "该箱号数量为1不可以进行拆包操作！",
                        type: "warning",
                      });
                      return;
                    } else if (resp.data.list[0].fcCode != localStorage.getItem("fcCode") || "") {
                      this.$message({
                        message: "该工厂没有此箱号！",
                        type: "warning",
                      });
                      return;
                    } else {
                      this.unpackDate = resp.data.list[0];
                      this.unpack.fcCode = this.unpackDate.fcCode;
                      this.unpack.batchNo = this.unpackDate.batchNo;
                      this.unpack.matQuan = this.unpackDate.matQuan;
                      this.unpack.matName = this.unpackDate.matName;
                      this.unpack.matCode = this.unpackDate.matCode;
                      this.unpack.createTime = this.unpackDate.createTime;
                      this.unpack.lcCode = this.unpackDate.lcCode;
                      this.unpack.wiStatus = this.unpackDate.wiStatus;
                      this.unpack.mtUnit = this.unpackDate.mtUnit;
                      this.unpack.matSpecs = this.unpackDate.matSpecs;
                      this.unpack.matCreateTime = this.unpackDate.matCreateTime;
                      this.unpack.whCode = this.unpackDate.whCode;
                      this.unpack.orderCode = this.unpackDate.orderCode;
                      this.unpack.boxBarcode = this.unpackDate.boxBarcode;
                      this.lcCodeByLcType = this.unpackDate.lcCode;
                    }
                  } else {
                    this.$message({
                      message: resp.message,
                      type: "warning",
                    })
                    this.unpackDate = "";
                  }
                });

          },
          /**
           * 根据工厂查询id
           */
          getLmIdByFccode() {
            this.$http
                .request({
                  url: "/api/location/getLocationMenuId",
                  method: "GET",
                  params: {
                    fcCode: localStorage.getItem("fcCode") || "",
                  },
                })
                .then((res) => {
                  if (res.status == 100) {
                    this.fcCodeLmId = res.data.list[0].lmId;
                    this.getLocationMenu();
                  } else {
                    this.$message.error("错误");
                  }
                });
          },
            // 打印
          async labelPrint(){
              if(this.checkOutsourceList.length == 0){
                this.$message({
                  type: "warning",
                  message: "请选择！",
                });
                return
              }
              if(this.checkOutsourceList.length > 1){
                this.$message({
                  type: "warning",
                  message: "请选择一个打印！",
                });
                return
              }

              this.$http
                  .request({
                    url: "/api/outsource/getOutsourceDetailsPrint",
                    method: "GET",
                    params: {

                      boxBarCode: this.checkOutsourceList[0].boxBarcode || null,
                    },
                  })
                  .then((resp) => {
                    if (resp.status == 100) {




                      var produceTime = moment(this.checkOutsourceList[0].matCreateTime).format("YYYYMMDD");
                      var printTime = moment().format("YYYY-MM-DD");
                      var qrCode = this.checkOutsourceList[0].orderCode+","+this.checkOutsourceList[0].matCode+","
                      +","+this.checkOutsourceList[0].verdorCode+","+this.checkOutsourceList[0].whCode+",,"+this.checkOutsourceList[0].batchNo+
                      ","+this.checkOutsourceList[0].heatNumber+","+this.checkOutsourceList[0].matSpecs+","+resp.data[0].checkType+","+this.checkOutsourceList[0].matQuan+
                      ","+this.checkOutsourceList[0].palletCode+","+this.checkOutsourceList[0].boxBarcode+","+produceTime;
                      this.labelPrintData = {
                        value1: this.checkOutsourceList[0].boxBarcode,
                        value2: qrCode,
                        soCode:resp.data[0].soCode,
                        matCode:this.checkOutsourceList[0].matCode,
                        matName:this.checkOutsourceList[0].matName,
                        whCode:this.checkOutsourceList[0].whCode,
                        printTime:printTime,
                        matQuan:this.checkOutsourceList[0].matQuan,
                        batchNo:this.checkOutsourceList[0].batchNo,
                        palletCode:this.checkOutsourceList[0].palletCode,
                        boxBarcode:this.checkOutsourceList[0].boxBarcode,
                        laOutsouceCode:resp.data[0].laOutsouceCode,
                        wxName:resp.data[0].wxName,
                        isFg:this.checkOutsourceList[0].checkResult='20'?'否':'是',
                        type:resp.data[0].checkType,

                      }
                    }
                  })
                  .catch((error) => {
                    this.$message({
                      message: "操作失败",
                      type: "warning",
                    });
                  });
              this.labelPrintShow = true

            }
        },
        activated(){
            /* 获取所有的通道 */
            this.getSysWarehouseAll();
            /* 获取所有的库位 */
            this.getSysLocationAll();
            this.getOutsource();
            this.getWarehouse();
            /* 获取首页的数据 */
            this.getTableData();
            this.getTime();

        },
    };
</script>
<style>
    .dao {
        float: right;
        margin-top: -2%;
        padding-bottom: 10px;
    }
    .div span {
        margin-left: 50px;
    }

    .table table {
        margin-top: 20px;
    }

    .table table tr td {
        width: 100px;
        height: 50px;
        border: 1px solid black;
        text-align: center;
    }

    .table table tr th {
        width: 100px;
        height: 80px;
        border: 1px solid black;
        font-weight: 800;
        font-size: 18px;
    }

    .td td {
        font-weight: 800;
    }
</style>
